import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import OptimizeModule from 'views/OptimizeView/OptimizeModule'

export default function OptimizeWipView(): ReactElement {
  const { t } = useTranslation()

  return <OptimizeModule regularOptJobType="regular_wip" title={t('Draft production plan')} moduleName="optimizewip" />
}
